module.exports = __webpack_public_path__ + "static/img/newsimg2.efd037b6.jpg";